const types = {
	SET_BREADCRUMB: 'SET_BREADCRUMB',
	MERGE_BREADCRUMB: 'MERGE_BREADCRUMB'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/breadcrumb/mutation-types.js